<div class="container">
    <lib-no-data
        [iconName]="'not-found'"
        [title]="'Sorry... The page you’re looking for was not found.'"
        [text]="'Please check the URL or '"
        [linkText]="'Go to Dashboard'"
        (linkAction)="onLinkActionClicked()"
    >
    </lib-no-data>
</div>
